import React, { useEffect, useState } from "react";
import Bar from "./Bar";
import Bar_3 from "./Bar_3";

function Bar_gestione() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isZooming, setIsZooming] = useState(false);  // Stato per gestire lo zoom

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);

            // Verifica se la larghezza della finestra è cambiata drasticamente (differenza maggiore di 50px)
            if (Math.abs(window.innerWidth - windowWidth) > 50) {
                setIsZooming(true); // Probabile zoom
            } else {
                setIsZooming(false); // Se la larghezza cambia poco, non è uno zoom
            }
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [windowWidth]);  // Usa windowWidth come dipendenza per rilevare il cambiamento

    // Se si sta facendo zoom, non mostrare nulla
    if (isZooming) {
        return null;  // Mostra nulla o un altro elemento specifico durante lo zoom
    }

    return (
        <div>
            {windowWidth > 1400 ? (
                <Bar />
            ) : (
                <Bar_3 />
            )}
        </div>
    );
}

export default Bar_gestione;
